import script from "./VerifyAuthCode.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyAuthCode.vue?vue&type=script&setup=true&lang=js"

import "./VerifyAuthCode.vue?vue&type=style&index=0&id=99f22114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99f22114"]])

export default __exports__